export enum OcbPgpKeyScopes {
    Decryption = 1,
    Encryption = 2,
}
